import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClinicDoctorsAddPage } from './clinic-doctors-add';
import { SignaturePadModule } from 'angular2-signaturepad';

@NgModule({
  declarations: [
    ClinicDoctorsAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ClinicDoctorsAddPage),
    SignaturePadModule
  ],
})
export class ClinicDoctorsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/clinic-doctors-add/clinic-doctors-add.module.ts